import BuyInsuranceCarServ from '../../services/buyInsuranceCar'
import * as CONST from '../../configs/constants/BuyInsurance'
import Utils from '../../configs/constants/Utils'
import moment from 'moment'
import { history } from "../../history"
import ManageInsuranceCarServ from '../../services/manageInsuranceCar'
import { BaseAppConfigs } from 'base-app'


export const ACTION_TOGGLEBBTNDS = 'ACTION_TOGGLEBBTNDS'


export const CALL_BACK_ID_TYPE = 'CALL_BACK_ID_TYPE';
export const CALL_BACK_TOGGLE_NHAN_BAN_CUNG = 'CALL_BACK_TOGGLE_NHAN_BAN_CUNG';
export const CALL_BACK_TOGGLE_TT_NGUOIBAN = 'CALL_BACK_TOGGLE_TT_NGUOIBAN';
export const CALL_BACK_TOGGLE_EXPRESS = 'CALL_BACK_TOGGLE_EXPRESS';
export const CALL_BACK_RECEIPT_INSURANCE = 'CALL_BACK_RECEIPT_INSURANCE';
export const CALL_BACK_METHOD_INTERNET_BANKING = 'CALL_BACK_METHOD_INTERNET_BANKING';
export const CALL_BACK_METHOD_VISA_CARD = 'CALL_BACK_METHOD_VISA_CARD';
export const CALL_BACK_METHOD_ATM = 'CALL_BACK_METHOD_ATM';
export const CALL_BACK_METHOD_QR = 'CALL_BACK_METHOD_QR';
export const CALL_BACK_AGREE_PAYMENT = 'CALL_BACK_AGREE_PAYMENT';
export const CALL_BACK_ALTER_BANK_NAME = 'CALL_BACK_ALTER_BANK_NAME';
export const CALL_BACK_ALTER_BRANCH_NAME = 'CALL_BACK_ALTER_BRANCH_NAME';
export const ACTION_CHOOSE_VALUEVEHICLE_CURRENT = 'ACTION_CHOOSE_VALUEVEHICLE_CURRENT';

export const ACTION_UPDATE_ACTIVE_STEP = 'ACTION_UPDATE_ACTIVE_STEP'
export const ACTION_CREATE_CONSTRACT = 'ACTION_CREATE_CONSTRACT'

export const ACTION_CREATE_NEW_OWNER = 'ACTION_CREATE_NEW_OWNER'
export const ACTION_IS_LOADING = 'ACTION_IS_LOADING'
export const ACTION_IS_CAl_FEE = 'ACTION_IS_CAl_FEE'
export const ACTION_GET_USER_INFO = 'ACTION_GET_USER_INFO'
export const ACTION_GET_PARTNER_LIST = 'ACTION_GET_PARTNER_LIST'
export const ACTION_GET_ROLE = 'ACTION_GET_ROLE'


export const getUserInfo = () => {
  return async (dispatch, getState) => {
    try {
      const user = getState().auth.user
      // console.log(user);
      dispatch({
        type: ACTION_GET_USER_INFO,
        payload: user
      })
    } catch (error) {
      // console.log(error)
    }
  }
}

export const getRole = () => {
  return async (dispatch, getState) => {
    try {
      const roles = getState().navbar.roles
      // console.log("dunglhq roles: " + JSON.stringify(roles, null, 2))
      dispatch({
        type: ACTION_GET_ROLE,
        payload: roles
      })
    } catch (error) {
      // console.log(error)
    }
  }
}

export const chooseSelect = (action, data) => {
  return async (dispatch) => {
    try {

      dispatch({
        type: action,
        payload: data
      })

    } catch (error) {
      // console.log(error)
    }
  }
}

export const checkInfoVehicle = (formik, idNum) => {
  return async (dispatch) => {
    const res = await BuyInsuranceCarServ.checkInfoVehicle(idNum)
    // console.log(res);

    if (res.status === CONST.SUCCESS_CODE) {

      formik.setFieldValue('vehicleStatus', res.data.vehicleStatus);
      formik.setFieldValue('vehicleType', res.data.vehicleType.id);
      formik.setFieldValue(`capacityType`, res.data.vehicleType.capacityType);
      formik.setFieldValue('manufacturerName', res.data.manufacturerName);
      formik.setFieldValue('brandName', res.data.brandName);
      formik.setFieldValue('usage', res.data.usage);
      formik.setFieldValue('frameNo', res.data.frameNo);

      formik.setFieldValue('machineNo', res.data.machineNo);
      formik.setFieldValue('issPlace', res.data.issPlace);
      formik.setFieldValue('issDate', res.data.issDate);

      formik.setFieldValue('initValue', res.data.initValue);

    }

  }
}




export const getContact = (id) => {
  return async (dispatch) => {
    const res = await BuyInsuranceCarServ.getContact(id)
    // console.log(res);
  }
}


export const checkInfoContact = (formik, id, step) => {
  return async (dispatch) => {
    if (formik.values["idOwnerNum"] === '') return
    const res = await BuyInsuranceCarServ.checkInfoContact(id)

    // const res =await HttpClient.get(API.API_URL + API.API_CHECK_INFO_BY_ID + formik.values["idOwnerNum"], { params: { date: new Date().getMilliseconds() } })
    // console.log(res);
    if (res.status === CONST.SUCCESS_CODE) {
      if (step === 6) {
        formik.setFieldValue('vatIdContact', res.data.id);
        formik.setFieldValue('vatIdType', res.data.icType);
        formik.setFieldValue('vatName', res.data.fullName);
        formik.setFieldValue('vatIdNum', res.data.icNo);
        formik.setFieldValue('vatPhone', res.data.phoneNumber);
        formik.setFieldValue('vatEmail', res.data.email);
        formik.setFieldValue('ownerSex', res.data.gender);
        formik.setFieldValue('vatAddr', res.data.address);
      } else
        if (formik.values["idType"] !== 'MST') {
          formik.setFieldValue('idContact', res.data.id);
          formik.setFieldValue('ownerName', res.data.fullName);
          formik.setFieldValue('dateOfBirth', res.data.dateOfBirth);
          formik.setFieldValue('ownerPhone', res.data.phoneNumber);
          formik.setFieldValue('ownerEmail', res.data.email);
          formik.setFieldValue('ownerSex', res.data.gender);
          formik.setFieldValue('ownerAddr', res.data.address);
        } else {
          formik.setFieldValue('idContact', res.data.id);
          formik.setFieldValue('ownerName', res.data.fullName);
          formik.setFieldValue('issuedDate', res.data.issuedDate);
          formik.setFieldValue('ownerPhone', res.data.phoneNumber);
          formik.setFieldValue('ownerEmail', res.data.email);
          formik.setFieldValue('idPlace', res.data.issuedPlace);
          formik.setFieldValue('ownerAddr', res.data.address);
        }
    }
  }
}


export const calFee = (formik, info, paymentMethod, printedCertType) => {
  let feeShip = 0
  let contractInfo = info
  if (printedCertType === 'DELIVERY') {
    feeShip = Number.parseInt(contractInfo.shipingFee)
  }
  let fee;
  // // console.log("contractinfo " + JSON.stringify(contractInfo, null, 2))
  if (paymentMethod === CONST.PAY_FUND_GPAY) {
    fee = Number.parseInt(contractInfo.funTransferPayFee) + Number.parseInt(feeShip)
  } else {
    fee = feeShip
  }
  formik.setFieldValue("feeVAT", fee)
}

export const getConstractInfo = (formik, values) => {
  return async (dispatch) => {

    const contractInfo = values["contractInfo"]
    const res = await BuyInsuranceCarServ.getConstractInfo(contractInfo.id)
    // console.log("getConstractInfo " + JSON.stringify(res));
    if (res.status === CONST.SUCCESS_CODE) {
      formik.setFieldValue("contractInfo", res.data)
      formik.setFieldValue("contractCode", res.data.contractCode)
      formik.setFieldValue("totalFee", res.data.totalFee)
      // formik.setFieldValue("feeVAT", Utils.formatCurrency(res.data.vatfee))
      calFee(formik, res.data, formik.values["paymentMethod"], formik.values["printedCertType"])
      formik.setFieldValue("totalFeeInclVAT", res.data.totalFeeInclVAT)

      formik.setFieldValue("vehicles", res.data.vehicles[0])

      res.data.insurances.map((insurance, i) => {

        if (insurance.insuranceCode === 'CAR_TNDS') {

          formik.setFieldValue("toggleBBTNDS", insurance.isEnable)
          formik.setFieldValue("feeCAR_TNDS", Utils.formatCurrency(insurance.fee))
          if (insurance.startValueDate !== null) {
            formik.setFieldValue("dateInsuranceFrom", moment(insurance.startValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('DD-MM-YYYY'))
            formik.setFieldValue("dateInsuranceTo", moment(insurance.endValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('DD-MM-YYYY'))
            formik.setFieldValue("timeInsuranceFrom", moment(insurance.startValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('HH:mm'))
            formik.setFieldValue("timeInsuranceTo", moment(insurance.endValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('HH:mm'))
          }
        } else if (insurance.insuranceCode === 'CAR_TNDS_TN') {
          formik.setFieldValue("toggleTNDSTN", insurance.isEnable)
          formik.setFieldValue("feeCAR_TNDS_TN", Utils.formatCurrency(insurance.fee))
        } else if (insurance.insuranceCode === 'CAR_VATCHAT') {
          formik.setFieldValue("toggleVC", insurance.isEnable)
          if (insurance.startValueDate !== null) {
            formik.setFieldValue("feeCAR_VATCHAT", Utils.formatCurrency(insurance.fee))
            formik.setFieldValue("dateInsuranceVCFrom", moment(insurance.startValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('DD-MM-YYYY'))
            formik.setFieldValue("dateInsuranceVCTo", moment(insurance.endValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('DD-MM-YYYY'))
            formik.setFieldValue("timeInsuranceVCFrom", moment(insurance.startValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('HH:mm'))
            formik.setFieldValue("timeInsuranceVCTo", moment(insurance.endValueDate.replace("Z", ""), 'YYYY-MM-DDTHH:mm:ss').format('HH:mm'))
          }
        } else if (insurance.insuranceCode === 'CAR_CONNGUOI') {
          formik.setFieldValue("toggleTNLPL", insurance.isEnable)
          formik.setFieldValue("feeCAR_CONNGUOI", Utils.formatCurrency(insurance.fee))
        } else if (insurance.insuranceCode === 'CAR_HANGHOA') {
          formik.setFieldValue("toggleHH", insurance.isEnable)
          // console.log("fee hang hoa " + insurance.fee + "  " + Utils.formatCurrency(insurance.fee))
          formik.setFieldValue("feeCAR_HANGHOA", Utils.formatCurrency(insurance.fee))
        }

      })
      // const res2 = await BuyInsuranceCarServ.getContactByContractId(contractInfo.id)
      // if (res2.status === CONST.SUCCESS_CODE) {
      formik.setFieldValue("idContact", res.data.owner.id)
      formik.setFieldValue("idOwnerNum", res.data.owner.icNo)
      formik.setFieldValue("ownerName", res.data.owner.fullName)
      formik.setFieldValue("ownerAddr", res.data.owner.address)
      formik.setFieldValue("ownerPhone", res.data.owner.phoneNumber)
      formik.setFieldValue("ownerEmail", res.data.owner.email)

      formik.setFieldValue("templateName", Utils.removeVietnameseTones(res.data.owner.fullName).replace(" ", "") + '_' + res.data.vehicles[0].numberPlate)

      dispatch({
        type: ACTION_UPDATE_ACTIVE_STEP,
        payload: 4
      })
      // }
    }

    dispatch({
      type: ACTION_IS_LOADING,
      payload: false
    })
  }
}















export const createVehicle = (formik, values) => {
  return async (dispatch) => {
    // console.log("create contract");

    const contractInfo = values["contractInfo"]
    // console.log(contractInfo);

    if (contractInfo.id === '') {
      let contractInfoObject = JSON.stringify({
        contractType: "CC",
        contractValue: values["requireVehicle"].toString().replace(/[^\d]/g, ""),
        vehicleValue: values["initValue"].toString().replace(/[^\d]/g, "")
      });

      if (values["templateId"] !== null && values["templateId"] !== '') {
        contractInfoObject = JSON.stringify({
          contractType: "CC",
          contractValue: values["requireVehicle"].toString().replace(/[^\d]/g, ""),
          vehicleValue: values["initValue"].toString().replace(/[^\d]/g, ""),
          id: values["templateId"]
        });
      }

      const res = await BuyInsuranceCarServ.createConstract(contractInfoObject)
      // console.log(res);

      if (res.status === CONST.SUCCESS_CODE) {
        // console.log("create " + res.status);
        // res.data.insurances[0].buyEnable = false
        formik.setFieldValue("contractInfo", res.data)

        res.data.insurances.map((insurance, i) => {

          if (insurance.insuranceCode === 'CAR_TNDS') {
            formik.setFieldValue("buyCAR_TNDS", insurance.buyEnable)

          } else if (insurance.insuranceCode === 'CAR_TNDS_TN') {
            formik.setFieldValue("buyCAR_TNDS_TN", insurance.buyEnable)
          } else if (insurance.insuranceCode === 'CAR_VATCHAT') {
            formik.setFieldValue("buyCAR_VATCHAT", insurance.buyEnable)
          } else if (insurance.insuranceCode === 'CAR_CONNGUOI') {
            formik.setFieldValue("buyCAR_CONNGUOI", insurance.buyEnable)
          } else if (insurance.insuranceCode === 'CAR_HANGHOA') {
            formik.setFieldValue("buyCAR_HANGHOA", insurance.buyEnable)
          }

        })

        let addTermsMains = []
        let addTermsAlls = []
        const keys = ["BS01", "BS02", "BS06", "BS09", "BS13"];
        res.data.insuranceAddons.sort((a, b) => (a.addonCode > b.addonCode) ? 1 : -1)

        keys.map((key, i) => {
          res.data.insuranceAddons.map((insuranceAddon, j) => {
            if (key === insuranceAddon.addonCode && insuranceAddon.buyEnable === true) {
              addTermsMains = [...addTermsMains, insuranceAddon]
            }
          })
        })

        res.data.insuranceAddons.map((insuranceAddon, j) => {
          let exist = false;
          keys.map((key, i) => {
            if (key === insuranceAddon.addonCode) {
              exist = true;
            }
          })
          if (!exist && insuranceAddon.buyEnable === true) {
            addTermsAlls = [...addTermsAlls, insuranceAddon]
          }

        })

        formik.setFieldValue("addTermsMain", addTermsMains)
        formik.setFieldValue("addTermsAll", addTermsAlls)


        res.data.insurances.map((insurance, i) => {
          // // console.log("addTermsMains " + JSON.stringify(addTermsMains, null, 2));

          if (insurance.insuranceCode === 'CAR_TNDS') {

            formik.setFieldValue("toggleBBTNDS", insurance.isEnable)
            formik.setFieldValue("durationBBTNDS", insurance.duration)
          } else if (insurance.insuranceCode === 'CAR_TNDS_TN') {
            formik.setFieldValue("toggleTNDSTN", insurance.isEnable)
            formik.setFieldValue("xTrieuNguoiVu", Number.parseInt(insurance.liability1, 10) / 1000000)
            formik.setFieldValue("xTrieuTaiSanVu", Number.parseInt(insurance.liability2, 10) / 1000000)
            formik.setFieldValue("xTrieuTaiHanhKhach", Number.parseInt(insurance.liability3, 10) / 1000000)
          } else if (insurance.insuranceCode === 'CAR_VATCHAT') {
            formik.setFieldValue("toggleVC", insurance.isEnable)
            formik.setFieldValue("bhInc", insurance.value2 === null ? '' : insurance.value2)
            formik.setFieldValue("durationBHVC", insurance.duration)
          } else if (insurance.insuranceCode === 'CAR_CONNGUOI') {
            formik.setFieldValue("toggleTNLPL", insurance.isEnable)
            formik.setFieldValue("xTrieuNguoiTrenXe", Number.parseInt(insurance.liability1, 10) / 1000000)
            formik.setFieldValue("numInCar", insurance.count1 === null ? '' : insurance.count1)
          } else if (insurance.insuranceCode === 'CAR_HANGHOA') {
            formik.setFieldValue("toggleHH", insurance.isEnable)
            if (formik.values["capacityType"] === 'SEAT')
              formik.setFieldValue("toggleHH", false)
            formik.setFieldValue("xTrieuHangHoaVanChuyen", Number.parseInt(insurance.liability1, 10) / 1000000)
            formik.setFieldValue("grossTon", insurance.count1 === null ? '' : insurance.count1)
          }

        })




        // res.data.contractValue = values["requireVehicle"].toString().replace(/[^\d]/g, "")
        // formik.setFieldValue("contractInfo", res.data)

        // const resUpdate = await BuyInsuranceCarServ.updateConstract(res.data)
        // // console.log("update " + resUpdate.status);
        // if (resUpdate.status === 200) {

        const infos = JSON.stringify({
          vehicleStatus: values["vehicleStatus"],
          numberPlate: values["numberPlate"],
          usage: values["usage"],
          issPlace: values["issPlace"],
          issDate: values["issDate"],
          vehicleTypeId: values["vehicleType"],
          manufacturerName: values["manufacturerName"],
          brandName: values["brandName"],
          initValue: values["initValue"].toString().replace(/[^\d]/g, ""),
          frameNo: values["frameNo"],
          machineNo: values["machineNo"],
          seats: values["seats"],
          loads: Number.parseFloat(values["loads"]),
          contractValue: values["requireVehicle"].toString().replace(/[^\d]/g, ""),
          contractId: res.data.id
        });

        // console.log(infos);
        const resVehicle = await BuyInsuranceCarServ.createVehicle(infos)
        // console.log(resVehicle);
        if (resVehicle.status === 200) {
          formik.setFieldValue("vehicleId", resVehicle.data.id)
          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 1
          })
        }
        // }
      }

      const today = new Date()
      const time = today.getHours() + ':' + today.getMinutes()
      formik.setFieldValue("timeInsuranceFrom", time)
      formik.setFieldValue("timeInsuranceTo", time)
      formik.setFieldValue("timeInsuranceVCFrom", time)
      formik.setFieldValue("timeInsuranceVCTo", time)

    } else {

      contractInfo.contractValue = values["requireVehicle"].toString().replace(/[^\d]/g, "")
      // console.log(contractInfo);

      formik.setFieldValue("contractInfo", contractInfo)
      const resUpdate = await BuyInsuranceCarServ.updateConstract(contractInfo)
      // console.log("update " + resUpdate.status);
      if (resUpdate.status === 200) {



        let resVehicle
        let infos
        if (values["vehicleId"] === '') {
          infos = JSON.stringify({
            vehicleStatus: values["vehicleStatus"],
            numberPlate: values["numberPlate"],
            usage: values["usage"],
            issPlace: values["issPlace"],
            issDate: values["issDate"],
            vehicleTypeId: values["vehicleType"],
            manufacturerName: values["manufacturerName"],
            brandName: values["brandName"],
            initValue: values["initValue"].toString().replace(/[^\d]/g, ""),
            frameNo: values["frameNo"],
            machineNo: values["machineNo"],
            seats: values["seats"],
            loads: values["loads"],
            contractValue: values["requireVehicle"].toString().replace(/[^\d]/g, ""),
            contractId: contractInfo.id
          });
          resVehicle = await BuyInsuranceCarServ.createVehicle(infos)
        }
        else {
          infos = JSON.stringify({
            id: values["vehicleId"],
            vehicleStatus: values["vehicleStatus"],
            numberPlate: values["numberPlate"],
            usage: values["usage"],
            issPlace: values["issPlace"],
            issDate: values["issDate"],
            vehicleTypeId: values["vehicleType"],
            manufacturerName: values["manufacturerName"],
            brandName: values["brandName"],
            initValue: values["initValue"].toString().replace(/[^\d]/g, ""),
            frameNo: values["frameNo"],
            machineNo: values["machineNo"],
            seats: values["seats"],
            loads: values["loads"],
            contractValue: values["requireVehicle"].toString().replace(/[^\d]/g, ""),
            contractId: contractInfo.id
          });
          // console.log(infos);
          resVehicle = await BuyInsuranceCarServ.updateVehicle(infos)
        }
        // console.log(resVehicle);

        if (resVehicle.status === 200) {
          formik.setFieldValue("vehicleId", resVehicle.data.id)
          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 1
          })
        }
      }
    }

    dispatch({
      type: ACTION_IS_LOADING,
      payload: false
    })
  }
}

export const updateInsurance = (formik, values) => {
  return async (dispatch) => {

    const infos = JSON.stringify({
      id: values["contractInfo"].id,
      companyId: values["companyId"]

    });

    const getCity = async () => {

      let cities = null
      if (typeof (Storage) !== 'undefined') {
        cities = JSON.parse(window.sessionStorage.getItem("cities"));
      }
      if (cities === null || cities.length === 0) {
        const res = await BuyInsuranceCarServ.getCity()
        if (res.status === 200) {
          let list = res.data.map((item, i) => {
            item.value = item.vn
            item.label = item.vn

            return item
          })
          window.sessionStorage.setItem("cities", JSON.stringify(list, null, 2));
          formik.setFieldValue("suggCity", list)
          cities = list
        }
      } else {
        formik.setFieldValue("suggCity", cities)
      }

      console.log("cities: " + JSON.stringify(cities, null, 2))


      let districts = null
      if (typeof (Storage) !== 'undefined') {
        districts = JSON.parse(window.sessionStorage.getItem("districts"));
      }
      if (districts === null || districts.length === 0) {
        const res1 = await BuyInsuranceCarServ.getDistricts()
        if (res1.status === 200) {
          let list = res1.data.map((item, i) => {
            item.value = item.vn
            item.label = item.vn
            return item
          })
          window.sessionStorage.setItem("districts", JSON.stringify(list, null, 2));
          // setDistricts(list)
          formik.setFieldValue("districts", list)
          districts = list
        }
      } else {
        formik.setFieldValue("districts", districts)
      }

      let wards = null
      if (typeof (Storage) !== 'undefined') {
        wards = JSON.parse(window.sessionStorage.getItem("wards"));
      }
      if (wards === null || wards.length === 0) {
        const res2 = await BuyInsuranceCarServ.getWards()
        if (res2.status === 200) {
          let list = res2.data.map((item, i) => {
            item.value = item.vn
            item.label = item.vn
            return item
          })
          window.sessionStorage.setItem("wards", JSON.stringify(list, null, 2));
          formik.setFieldValue("wards", list)
          wards = list
        }
      } else {
        formik.setFieldValue("wards", wards)
      }

    }

    const resUpdate = await BuyInsuranceCarServ.updateConstract(infos)
    // console.log(resUpdate)
    if (resUpdate.status === CONST.SUCCESS_CODE) {

      if (values["templateId"] !== null && values["templateId"] !== '') {
        const res2 = await BuyInsuranceCarServ.getContactByContractId(values["templateId"])
        // console.log(res2)
        if (res2.status === CONST.SUCCESS_CODE) {
          formik.setFieldValue("idContact", res2.data.id)
          formik.setFieldValue("idOwnerNum", res2.data.icNo)
          formik.setFieldValue("ownerName", res2.data.fullName)
          // formik.setFieldValue("ownerAddr", res2.data.address)
          formik.setFieldValue("ownerPhone", res2.data.phoneNumber)
          formik.setFieldValue("ownerEmail", res2.data.email)
          formik.setFieldValue('idType', res2.data.icType);
          formik.setFieldValue('custType', res2.data.type);
          formik.setFieldValue('dateOfBirth', res2.data.dateOfBirth);
          formik.setFieldValue('ownerSex', res2.data.gender);
          formik.setFieldValue('idPlace', res2.data.idPlace);

          // console.log("addresses: " + JSON.stringify(formik.values["suggCity"], null, 2))
          res2.data.addresses.map((addrs, i) => {

            if (addrs.type === 'HOME') {

              let cities = null
              if (typeof (Storage) !== 'undefined') {
                cities = JSON.parse(window.sessionStorage.getItem("cities"));
              }
              if (cities === null || cities.length === 0) {
                const res = BuyInsuranceCarServ.getCity()
                if (res.status === 200) {
                  let list = res.data.map((item, i) => {
                    item.value = item.vn
                    item.label = item.vn

                    return item
                  })
                  window.sessionStorage.setItem("cities", JSON.stringify(list, null, 2));
                  formik.setFieldValue("suggCity", list)
                  cities = list
                }
              } else {
                formik.setFieldValue("suggCity", cities)
              }

              console.log("cities: " + JSON.stringify(cities, null, 2))


              let districts = null
              if (typeof (Storage) !== 'undefined') {
                districts = JSON.parse(window.sessionStorage.getItem("districts"));
              }
              if (districts === null || districts.length === 0) {
                const res1 = BuyInsuranceCarServ.getDistricts()
                if (res1.status === 200) {
                  let list = res1.data.map((item, i) => {
                    item.value = item.vn
                    item.label = item.vn
                    return item
                  })
                  window.sessionStorage.setItem("districts", JSON.stringify(list, null, 2));
                  // setDistricts(list)
                  formik.setFieldValue("districts", list)
                  districts = list
                }
              } else {
                formik.setFieldValue("districts", districts)
              }

              let wards = null
              if (typeof (Storage) !== 'undefined') {
                wards = JSON.parse(window.sessionStorage.getItem("wards"));
              }
              if (wards === null || wards.length === 0) {
                const res2 = BuyInsuranceCarServ.getWards()
                if (res2.status === 200) {
                  let list = res2.data.map((item, i) => {
                    item.value = item.vn
                    item.label = item.vn
                    return item
                  })
                  window.sessionStorage.setItem("wards", JSON.stringify(list, null, 2));
                  formik.setFieldValue("wards", list)
                  wards = list
                }
              } else {
                formik.setFieldValue("wards", wards)
              }

              formik.setFieldValue("ownerCity", addrs.city)
              let itemCity = cities.find(item => item.value === addrs.city)
              console.log("itemCity: " + JSON.stringify(itemCity, null, 2))
              let filteredArray = districts.filter(district => district.cityId === itemCity.id)
              formik.setFieldValue("suggDistricts", filteredArray)
              formik.setFieldValue("ownerDistrict", addrs.district)
              let itemDistrict = filteredArray.find(item => item.value === addrs.district)
              let filteredArrayWards = wards.filter(ward => ward.districtId === itemDistrict.id)
              formik.setFieldValue("suggWards", filteredArrayWards)
              formik.setFieldValue("ownerWard", addrs.ward)
              formik.setFieldValue("ownerAddr", addrs.detail)

              console.log("get dunglhq 1")
            }

            // if (addrs.type === 'HOME') {
            //   console.log("ownerCity: " + addrs.city)
            //     formik.setFieldValue("ownerCity", addrs.city)
            //     formik.setFieldValue("ownerDistrict", addrs.district)
            //     formik.setFieldValue("ownerWard", addrs.ward)
            //     formik.setFieldValue("ownerAddr", addrs.detail)
            // }

          })

          // formik.setFieldValue("templateName", Utils.removeVietnameseTones(res2.data.owner.fullName).replace(" ", "") + '_' + res2.data.vehicles[0].numberPlate)


          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 2
          })
        } else {
          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 2
          })
        }
      }
    }

    dispatch({
      type: ACTION_IS_LOADING,
      payload: false
    })

  }

}

export const createContact = (formik, values) => {
  return async (dispatch) => {

    let isCreateContactSuccess = false
    let idContactAlter = null

    if (values['toggleChuyenQuyenThuHuong']) {
      if (values["idContactAlter"] === '') {
        const infos = JSON.stringify({
          fullName: values["bankName"],
          branchName: values["banchName"],
          address: values["bankAddr"],
          type: CONST.CUSTOMER_BANK
        });

        // console.log(infos);
        const resContact = await BuyInsuranceCarServ.createContact(infos)
        // console.log(resContact);

        if (resContact.status === CONST.SUCCESS_CODE) {
          isCreateContactSuccess = true
          formik.setFieldValue('idContactAlter', resContact.data.id)
          idContactAlter = resContact.data.id
        }

      } else {
        const infos = JSON.stringify({
          id: values["idContactAlter"],
          fullName: values["bankName"],
          branchName: values["banchName"],
          address: values["bankAddr"],
          type: CONST.CUSTOMER_BANK
        });

        // console.log(infos);
        const resContact = await BuyInsuranceCarServ.updateContact(infos)
        // console.log(resContact);

        if (resContact.status === CONST.SUCCESS_CODE) {
          isCreateContactSuccess = true
          idContactAlter = resContact.data.id
        }
      }
    } else {
      isCreateContactSuccess = true
    }

    if (isCreateContactSuccess) {

      isCreateContactSuccess = false

      // if (values["idContact"] == '') {
      const infos = JSON.stringify({
        icType: values["idType"],
        icNo: values["idOwnerNum"],
        issuedDate: values["issuedDate"] !== '' ? values["issuedDate"] : null,
        issuedPlace: values["idPlace"],
        fullName: values["ownerName"],
        dateOfBirth: values["dateOfBirth"] !== '' ? values["dateOfBirth"] : null,
        gender: values["ownerSex"] !== '' ? values["ownerSex"] : null,
        phoneNumber: values["ownerPhone"],
        email: values["ownerEmail"],
        // address: values["ownerAddr"],
        type: values["custType"],
        addresses: [
          {
            type: "HOME",
            city: values["ownerCity"],
            district: values["ownerDistrict"],
            ward: values["ownerWard"],
            detail: values["ownerAddr"]
          }
        ]
      });

      // console.log(infos);
      const resContact = await BuyInsuranceCarServ.createContact(infos)
      // console.log(resContact);
      let idContact = resContact.data.id
      if (resContact.status === CONST.SUCCESS_CODE) {
        formik.setFieldValue('idContact', resContact.data.id);
        isCreateContactSuccess = true
      }

      if (isCreateContactSuccess) {
        const contractInfo = formik.values["contractInfo"]
        const infos = JSON.stringify({
          ownerId: idContact,
          beneficiaryId: idContactAlter,
          benefitValue: values['toggleChuyenQuyenThuHuong'] ? values["amountAlter"].toString().replace(/[^\d]/g, "") : null,
          id: contractInfo.id,
        });
        // console.log(infos);
        const resUpdateConstract = await BuyInsuranceCarServ.updateConstract(infos)
        // console.log(resUpdateConstract);
        if (resUpdateConstract.status === CONST.SUCCESS_CODE) {

          if (formik.values["toggleBBTNDS"] && !formik.values["toggleVC"]) {
            dispatch(getConstractInfo(formik, values))
          } else {
            dispatch({
              type: ACTION_UPDATE_ACTIVE_STEP,
              payload: 3
            })
          }
        }
      }
    }

    dispatch({
      type: ACTION_IS_LOADING,
      payload: false
    })

  }
}

export const payContract = (formik, values) => {
  return async (dispatch) => {
    const infos = JSON.stringify({
      certNo: values['toggleprintedCert'] && values["printedCertType"] === 'DIRECT' ? values["certNo"] : '',
      paymentType: values["paymentMethod"],
      printedCertType: values['toggleprintedCert'] ? values["printedCertType"] : 'NONE',
      // certReceiverId: values["certReceiverId"],
      companyId: values["companyId"]
    });
    const res = await BuyInsuranceCarServ.payConstract(values["contractInfo"].id, infos)
    if (res.status === CONST.SUCCESS_CODE) {
      if (values["paymentMethod"] === CONST.PAY_FUND_TRANSFER)
        dispatch({
          type: ACTION_UPDATE_ACTIVE_STEP,
          payload: 5
        })
      else {
        // console.log(res);
        window.location.replace(res.data.url);
      }
    }
    dispatch({
      type: ACTION_IS_LOADING,
      payload: false
    })
  }
}

export const completeContract = (formik, values, paymentResult, hmac) => {
  return async (dispatch, getState) => {
    const {insId} = getState().auth.divayUserInfo;
    let taxInvoiceReceiverId = ''
    let certReceiverId = ''
    let isCallComplete = true
    if (values["invoiceOption"] === 'onwer') {
      taxInvoiceReceiverId = values["idContact"]
      const infos = JSON.stringify({
        fullName: values["ownerName"],
        phoneNumber: values["ownerPhone"],
        email: values["ownerEmail"],
        address: values["ownerAddr"],
        icNo: values["idOwnerNum"],
        id: values["idContact"],
      });

      // console.log(infos);
      const resContact = await BuyInsuranceCarServ.updateContact(infos)
      // console.log(resContact);

      if (resContact.status === CONST.SUCCESS_CODE) {

      } else
        isCallComplete = false

    } else if (values["invoiceOption"] === 'pers' || values["invoiceOption"] === 'copr') {
      const infos = JSON.stringify({
        icType: values["vatIdType"],
        icNo: values["vatIdNum"],
        fullName: values["vatName"],
        phoneNumber: values["vatPhone"],
        email: values["vatEmail"],
        address: values["vatAddr"],
        type: values["invoiceOption"] === 'pers' ? 'INV' : 'ORG'
      });

      // console.log(infos);
      const resContact = await BuyInsuranceCarServ.createContact(infos)
      // console.log(resContact);

      if (resContact.status === CONST.SUCCESS_CODE) {
        taxInvoiceReceiverId = resContact.data.id
      } else
        isCallComplete = false
    }

    if (values["printedCertType"] === 'DELIVERY') {
      const infos = JSON.stringify({
        fullName: values["shipName"],
        phoneNumber: values["shipPhone"],
        address: values["shipAddr"],
        addresses: [
          {
            type: "HOME",
            city: values["shipCity"],
            district: values["shipDistrict"],
            ward: values["shipWard"],
            detail: values["shipAddr"]
          }
        ],
        type: 'INV'
      });
      // console.log(infos);
      const resShipContact = await BuyInsuranceCarServ.createContact(infos)
      // console.log(resShipContact);

      if (resShipContact.status === CONST.SUCCESS_CODE) {
        certReceiverId = resShipContact.data.id
      } else
        isCallComplete = false
    }

    if (isCallComplete) {
      const infos = JSON.stringify({
        id: values["contractInfo"].id,
        taxInvoiceType: values["vatCustType"],
        taxInvoiceReceiverId: taxInvoiceReceiverId,
        certReceiverId: certReceiverId,
        isSaveTemplate: values["isSaveTemplate"],
        templateName: values["templateName"],
      })
      // console.log(infos);
      const resComplete = await BuyInsuranceCarServ.completeConstract(infos)
      // console.log(resComplete);

      if (resComplete.status === CONST.SUCCESS_CODE) {

        const infos2 = JSON.stringify([{
          id: values["contractInfo"].contractApprovalId,
          approvalStatus: "APPROVED"
        }])
        // console.log(infos2);
        if (formik.values["finishAction"] === "BUYNEW") {
          formik.resetForm()
          dispatch({
            type: ACTION_UPDATE_ACTIVE_STEP,
            payload: 0
          })
          history.push("/buy-insurance")
        } else {
          sessionStorage.clear();
          if (paymentResult === 'COMPLETE') {
            window.location.href = `${BaseAppConfigs.DIVAY_URL}/#/insurances/call-back?insId=${insId}&status=SUCCESS&hmac=${hmac}`
          } else {
            window.location.href = BaseAppConfigs.DIVAY_URL;
          }
        }

        // const resApproved = await BuyInsuranceCarServ.approvedConstract(infos2)
        // if (resApproved.status === CONST.SUCCESS_CODE) {

        // }
      }
    }

    dispatch({
      type: ACTION_IS_LOADING,
      payload: false
    })
  }
}


export const confirmContract = (info) => {
  return async (dispatch) => {

  }
}



// export const callDirectVNPay = () => {
//   return async (dispatch) => {
//     // console.log("vnpUrl1 ")
//     let vnpUrl = "http://sandbox.vnpayment.vn/paymentv2/vpcpay.html"

//     // const contractInfo = values["contractInfo"]
//     let infos = {
//       vnp_TmnCode: CONST.vnp_TmnCode,
//       vnp_HashSecret: CONST.vnp_HashSecret,
//       // vnp_TxnRef: values["contractCode"],
//       // vnp_Amount: values["vnp_Amount"],
//       // vnp_CreateDate: values["idPlace"],
//       // vnp_CurrCode: 'VND',
//       // vnp_IpAddr: values["dateOfBirth"],
//       // vnp_Locale: values["ownerSex"],
//       // vnp_OrderInfo: values["contractCode"],
//       // vnp_ReturnUrl: values["ownerEmail"],
//       // vnp_TxnRef: values["custType"],
//       // vnp_SecureHashType: values["custType"],
//       // vnp_SecureHash: values["custType"]

//       vnp_TxnRef: '12345',
//       vnp_Amount: '1000000',
//       vnp_CreateDate: '20200829103111',
//       vnp_CurrCode: 'VND',
//       vnp_IpAddr: '192.168.1.8',
//       vnp_Locale: 'vn',
//       vnp_OrderInfo: 'thanh toan hoa don',
//       vnp_ReturnUrl: 'http://domain.vn/VnPayReturn'

//     }
//     infos = sortObject(infos);

//     let querystring = require('qs');
//     let signData = CONST.vnp_HashSecret + querystring.stringify(infos, { encode: false });

//     let sha256 = require('sha256');

//     let secureHash = sha256(signData);

//     infos['vnp_SecureHashType'] = 'SHA256';
//     infos['vnp_SecureHash'] = secureHash;

//     vnpUrl += '?' + querystring.stringify(infos, { encode: true });

//     // const md5Hash = require("md5-hash")
//     // console.log("vnpUrl: " + vnpUrl)
//   }
// }

function sortObject(o) {
  var sorted = {},
    key, a = [];

  for (key in o) {
    if (o.hasOwnProperty(key)) {
      a.push(key);
    }
  }

  a.sort();

  for (key = 0; key < a.length; key++) {
    sorted[a[key]] = o[a[key]];
  }
  return sorted;
}


export const getPartners = () => {
  return async (dispatch, getState) => {
    try {
      const user = getState().auth.user
      getPartnerLists(dispatch, user.id)
      // console.log(user);
      dispatch({
        type: ACTION_GET_USER_INFO,
        payload: user
      })


    } catch (error) {
      // console.log(error)
    }
  }
}


const getPartnerLists = async (dispatch, user) => {
  // console.log("getPartners")
  let res = null

  res = await ManageInsuranceCarServ.getPartners(user)

  // console.log(res)
  if (res !== null && res.status === 200) {
    let list = res.data.map((item, i) => {
      item.value = item.id
      item.label = item.userCode
      item.check = false
      return item
    })
    dispatch({
      type: ACTION_GET_PARTNER_LIST,
      payload: list
    })
  }
}
